'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:DirectorCtrl
 * @description
 * # DirectorCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp')
    .controller('BaseSurveysCtrl',
    [
        '$scope', '$routeParams', '$location', '$http', 'Session', '$uibModal', 'ReportService', 'ApiUrl', 'SurveyService',
        function ($scope, $routeParams, $location, $http, Session, $uibModal, ReportService, ApiUrl, SurveyService) {

            var sessionObject = Session.getSessionObject();
            if (!sessionObject.isAuthenticated || !(sessionObject.isAdmin || sessionObject.isProjectAdmin)) {
                $location.url('/');
                return;
            }

            var _divisionapiUrl = ApiUrl.url('/Division/');
            var _surveyapiUrl = ApiUrl.url('/Survey/');

            $scope.surveyMgmtLoading = true;
            $scope.isAdmin = sessionObject.isAdmin;
            $scope.filterDivisions = [];

            $http.get(_divisionapiUrl + 'GetDivisionsByProjects')
                .then(function (response) {
                    $scope.divisions = response.data;

                    $scope.divisions.forEach(function (division) {
                        $http.get(_surveyapiUrl + 'GetBaseSurveysByDivision/' + division.DivisionID)
                            .then(function (response) {
                                division.mentorSurveys = [];
                                division.menteeSurveys = [];
                                response.data.forEach(function (survey) {
                                    if (survey.TargetID === 1) {
                                        division.mentorSurveys.push(survey);
                                        if (division.BaseMentorSurveyID === survey.SurveyID) {
                                            survey.IsBaseMentor = true;
                                        }
                                    }
                                    else if (survey.TargetID === 2) {
                                        division.menteeSurveys.push(survey);
                                        if (division.BaseMenteeSurveyID === survey.SurveyID) {
                                            survey.IsBaseMentee = true;
                                        }
                                    }
                                });
                                $scope.surveyMgmtLoading = false;
                            },
                            function (err) {
                                $location.path('error');
                            });
                    });
                    $scope.allDivisions = $scope.divisions; 
                    $http.get(ApiUrl.url('/Project/') + 'GetProjectsWhereUserIsAdmin')
                        .then(function (response) {
                            $scope.projects = response.data;
                            $scope.filterProjects = response.data;
                            if (sessionObject.surveyAdminProjectFilterID) {
                                $scope.filterProject = $scope.filterProjects.find(project => project.ProjectId === sessionObject.surveyAdminProjectFilterID);
                                $scope.selectProject();
                            }
                            else if ($scope.filterProjects.length === 1) {
                                $scope.filterProject = $scope.filterProjects[0];
                                $scope.selectProject();
                            }
                            if (sessionObject.surveyAdminDivisionFilterID) {
                                $scope.getDivisions($scope.filterProject);
                            }
                        });
                },
                function (err) {
                    $location.path('error');
                });

            $scope.getDivisions = function (project) {
                $http.get(ApiUrl.url('/Division/') + 'Divisions/' + project.ProjectId)
                    .then(function (response) {
                        $scope.filterDivisions = response.data;
                        if (sessionObject.surveyAdminDivisionFilterID) {
                            $scope.filterDivision = $scope.filterDivisions.find(division => division.DivisionID === sessionObject.surveyAdminDivisionFilterID);
                            $scope.selectDivision();
                        }
                    });
            };

            $scope.selectProject = function () {
                if ($scope.filterProject) {
                    // get the divisions
                    $scope.getDivisions($scope.filterProject);
                    // filter to the project group
                    $scope.projects = [];
                    $scope.projects.push($scope.filterProject);
                    $scope.filterProject.open = true;
                    $scope.divisions = [];  // clear the display list
                    for (var i = 0; i < $scope.allDivisions.length; i++) {
                        if ($scope.allDivisions[i].ProjectId === $scope.filterProject.ProjectId) {
                            $scope.allDivisions[i].open = false;
                            $scope.divisions.push($scope.allDivisions[i]);
                        }
                    }
                    sessionObject.surveyAdminProjectFilterID = $scope.filterProject.ProjectId;
                }
                else {
                    $scope.projects = $scope.filterProjects;
                    $scope.filterProjects.forEach(function (project) {
                        project.open = false;
                    });
                    $scope.divisions = $scope.allDivisions;
                    $scope.filterDivisions = []; // clear this list because there are is no project
                    sessionObject.surveyAdminProjectFilterID = null;
                }                
                Session.saveSessionObject(sessionObject);
            };

            $scope.selectDivision = function () {
                if ($scope.filterDivision) {
                    // filter to the division
                    $scope.divisions = [];  // clear the display list
                    for (var i = 0; i < $scope.allDivisions.length; i++) {
                        if ($scope.allDivisions[i].ProjectId === $scope.filterProject.ProjectId && $scope.allDivisions[i].DivisionID === $scope.filterDivision.DivisionID) {
                            $scope.allDivisions[i].open = true;
                            $scope.divisions.push($scope.allDivisions[i]);
                        }
                    }
                    sessionObject.surveyAdminDivisionFilterID = $scope.filterDivision.DivisionID;
                }
                else {
                    $scope.selectProject();
                    sessionObject.surveyAdminDivisionFilterID = null;
                }               
                Session.saveSessionObject(sessionObject);
            };

            $scope.activateBaseMentee = function (survey, division) {
                $http.post(_surveyapiUrl + 'ActivateBaseMentee/' + survey.SurveyID + '/' + division.DivisionID).then(function (response) {
                    if (response.data) {
                        //need to modify the local collection
                        division.menteeSurveys.forEach(function (s) {
                            if (s.SurveyID === survey.SurveyID) {
                                s.IsBaseMentee = true;
                            } else {
                                s.IsBaseMentee = false;
                            }
                        });
                    }
                }, function (err) {
                    $location.path('error');
                });
            };

            $scope.activateBaseMentor = function (survey, division) {
                $http.post(_surveyapiUrl + 'ActivateBaseMentor/' + survey.SurveyID + '/' + division.DivisionID).then(function (response) {
                    if (response.data) {
                        //need to modify the local collection
                        division.mentorSurveys.forEach(function (s) {
                            if (s.SurveyID === survey.SurveyID) {
                                s.IsBaseMentor = true;
                            } else {
                                s.IsBaseMentor = false;
                            }
                        });
                    }
                }, function (err) {
                    $location.path('error');
                });
            };


        }
    ]);